import {
  OpportunityCard,
  GenericOpportunityCardContent,
} from '../components/OpportunityCard';
import { UserCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSelector } from 'react-redux';
import { selectClients, selectClientsIsLoading } from '@/model/selectors';

const PRIORITY_STATUS = 'Highly recommended';

type OpportunityTryYourselfProps = {
  setShowInviteClientModal: (open: boolean) => void;
};

export function OpportunityTryYourself({
  setShowInviteClientModal,
}: OpportunityTryYourselfProps) {
  const clients = useSelector(selectClients);
  const clientsIsLoading = useSelector(selectClientsIsLoading);

  if (clients.length !== 0) return null;

  return (
    <OpportunityCard
      priorityStatus={PRIORITY_STATUS}
      isLoading={clientsIsLoading}
      cardContent={
        <GenericOpportunityCardContent
          icon={
            <UserCheck
              className="h-8 w-8"
              strokeWidth={1}
            />
          }
          title={'Invite Yourself'}
          subtitle="Demo Waterlily by inviting yourself via link or email."
        />
      }
      cardFooterContent={
        <Button
          className={'rounded-full'}
          onClick={() => {
            setShowInviteClientModal(true);
          }}
        >
          Get started
        </Button>
      }
    />
  );
}
